/*
 * This file is part of the Sylius package.
 *
 * (c) Paweł Jędrzejewski
 *
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */

(function ( $ ) {
    'use strict';

    $.fn.extend({
        variantPrices: function () {
            if ($('#sylius-variants-pricing').length > 0) {
                handleProductOptionsChange();
            } else if ($("#sylius-product-variants").length > 0) {
                handleProductVariantsChange();
            }
        }
    });
})( jQuery );

function handleProductOptionsChange() {
    $('[name*="sylius_add_to_cart[cartItem][variant]"]').on('change', function() {
        var $elem = $(this).parents('.product-info');
        var $selector = '';

        $elem.find('#sylius-product-adding-to-cart select').each(function() {
            var option = $(this).find('option:selected').val();
            $selector += '[data-' + $(this).attr('data-option') + '="' + option + '"]';
        });

        var $price = $elem.find('#sylius-variants-pricing').find($selector).attr('data-value');
        var $originalPrice = $elem.find('#sylius-variants-pricing').find($selector).attr('data-original');

        if ($price !== undefined) {
            $elem.find('#product-price').html($price);
            $elem.find('button[type=submit]').removeAttr('disabled');
        } else {
            $elem.find('#product-price').html($('#sylius-variants-pricing').attr('data-unavailable-text'));
            $elem.find('button[type=submit]').attr('disabled', 'disabled');
        }
        if ($originalPrice !== undefined) {
            $elem.find('#product-price').siblings('.price-cut').html($originalPrice);
        } else {
            $elem.find('#product-price').siblings('.price-cut').html('');
        }

        const path = $('#isoshop-variant-links').find($selector).data('value');

        if (path !== undefined) {
            const nextTitle = document.title;
            const nextState = { additionalInformation: 'Updated the URL with JS' };
            window.history.replaceState(nextState, nextTitle, path);
        }
    });
}

function handleProductVariantsChange() {
    $('[name="sylius_add_to_cart[cartItem][variant]"]').on('change', function(event) {
        var $elem = $(this).parents('.product-info');
        var $price = $(this).parents('tr').find('.sylius-product-variant-price').html();
        var $originalPrice = $(this).parents('tr').find('.sylius-product-variant-price').siblings('strike').html();
        $elem.find('#product-price').html($price);
        $elem.find('#product-price').siblings('.price-cut').html($originalPrice ? $originalPrice : '');

        const variantCode = $(event.currentTarget).val();
        const path = $('#isoshop-variant-links [data-variant-code="' + variantCode + '"]').data('value');

        if(path !== undefined) {
            const nextTitle = document.title;
            const nextState = { additionalInformation: 'Updated the URL with JS' };
            window.history.replaceState(nextState, nextTitle, path);
        }
    });
}
